/**
 * §10.8 Why Businesses Choose Kalki Ai Cloud — 6 differentiators.
 */

import React from 'react'
import {
  Boxes, ServerCog, Building2, Rocket, ShieldCheck, HeartHandshake, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { WHY_CHOOSE } from '../data'

const ICONS = { Boxes, ServerCog, Building2, Rocket, ShieldCheck, HeartHandshake, Sparkles }

export default function WhyChoose() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Why Kalki Ai Cloud</Eyebrow>
          <SectionHeading align="center"
            title={<>Six reasons operators{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">choose Kalki Ai Cloud.</span></>}
            subtitle="The differentiators that show up over and over in enterprise-desk conversations — unified stack, enterprise architecture, white-label economics, continuous innovation, security posture and customer-centric development."
          />
        </div>
        <FeatureGrid items={WHY_CHOOSE} icons={ICONS} cols={3} />
      </Container>
    </section>
  )
}
